import React, {useContext, useEffect, useState} from 'react';
import {Trans, useTranslation} from "react-i18next";
import {getLocation, clearSnapshot, saveSnapshot} from "@/lib/utils";
import InstallerContext from "@/context/InstallerContext";
import axios from "axios";
import defaultAvatar from "@/images/default_avatar.png";

const LoginWithButton = ({provider}) => {
  const step = 6;
  const {t} = useTranslation();
  const {data, setData} = useContext(InstallerContext);
  const [isLoggingIn, setIsLoggingIn] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const authToken = urlParams.get('auth_token');
    
    if (authToken) {
      // Remove auth_token from url
      const url = new URL(window.location);
      url.searchParams.delete('auth_token');
      window.history.replaceState({}, document.title, url);
      
      setIsLoggingIn(true);
      
      // Clear the snapshot
      clearSnapshot();
      
      axios.post(`https://id.leaderos.net/api/tokens/${authToken}/validate`, {}, {
        headers: {
          'X-Api-Key': data.apiKey
        }
      }).then((res) => {
        if (res.data.status) {
          setData({
            ...data,
            admin: {
              ...data.admin,
              username: res.data.data.username,
              realname: res.data.data.realname,
              email: res.data.data.email,
              avatar: res.data.data.avatar,
            }
          });
          setIsLoggedIn(true);
        }
      })
      .catch(error => {
        console.error("Error during authentication:", error);
      })
      .finally(() => {
        setIsLoggingIn(false);
      });
    }
  }, [setData]);
  
  
  const login = () => {
    if (isLoading) return;
    
    setIsLoading(true);
    
    // Save the current state to the local storage
    saveSnapshot(step, data).then(() => {
      // Redirect to the provider login page
      const redirect = window.location.origin + "/install";
      const location = getLocation();
      window.location.href = `https://id.leaderos.net/redirect?provider=${provider}&return=${redirect}&s=${location}`;
    });
  }
  
  const logout = () => {
    if (isLoading) return;
    
    setIsLoading(true);
    
    setData({
      ...data,
      admin: {
        ...data.admin,
        username: null,
        realname: null,
        email: null,
        avatar: null,
      }
    });
    setIsLoggedIn(false);
    
    // Remove auth_token from url
    const url = new URL(window.location);
    url.searchParams.delete('auth_token');
    window.history.replaceState({}, document.title, url);
    
    setIsLoading(false);
  }
  
  let avatar = data.admin.avatar;
  if (provider === 'minecraft') {
    avatar = `https://minotar.net/helm/${data.admin.realname}/128.png`;
  }
  if (avatar === null) {
    avatar = defaultAvatar;
  }
  
  if (isLoggingIn) {
    return (
        <div className="text-gray-800">
          {t('login_buttons.loading')}
        </div>
    )
  }
  
  if (isLoggedIn) {
    return (
        <div className="flex gap-3">
          <div className="border-r pr-3">
            <img src={avatar} className="w-16 h-16 rounded-lg" />
          </div>
          <div>
            <div className="text-gray-800 text-lg mb-1">
              <Trans
                  i18nKey='login_buttons.logged_in'
                  values={{user: data.admin.realname}}
                  components={{strong: <strong />}}
              />
            </div>
            
            <button
                onClick={logout}
                className={`cursor-pointer rounded-xl py-2 px-4 flex gap-3 bg-gray-400/25 text-gray-600/75 items-center group font-medium text-sm transition hover:bg-gray-400/40 ${isLoading ? 'opacity-50 pointer-events-none' : ''}`}
            >
              {t('login_buttons.logout')}
            </button>
          </div>
        </div>
    );
  }
  
  return (
      <button onClick={login} className={`cursor-pointer rounded-xl py-3 px-6 flex gap-3 bg-vox text-white items-center group font-medium transition hover:bg-vox/90 ${isLoading ? 'opacity-50 pointer-events-none' : ''}`}>
        {t(`login_buttons.${provider}`)}
      </button>
  );
};

export default LoginWithButton;